import { Encrypt } from "@/utils/crypto";
import { commonFetch, fetch } from "./fetch";

// 根据登录账号或手机号查询客户用户列表信息
function getFindByUserNameOrPhone(data: {
  userAccountOrPhone: string;
}): Promise<ByUserNameOrPhoneUserInfoList[]> {
  return commonFetch(
    "/crm-ems/v1/mallUser/mallUser/findByUserNameOrPhone",
    true,
    data
  );
}

// 账号密码登录
function fetchSubmitByAccount(data: LoginByAccountParams): Promise<LoginByAccount> {
  return fetch({
    url: "/crm-ems/v1/rbac/login",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

// 切换客户用户当前客户
function changeUserCurrentCustomer(
  data: ChangeCustomerParams
): Promise<ChangeCustomer> {
  return commonFetch(
    "/crm-ems/v1/mallUser/mallUser/changeUserCurrentCustomer",
    false,
    data
  );
}

// 登录成功时调用可切换的账号接口
function findByUserAccount(data: {
  userAccount: string;
}): Promise<ByUserNameOrPhoneUserInfoList[]> {
  return commonFetch(
    "/crm-ems/v1/mallUser/mallUser/findByUserAccount",
    true,
    data
  );
}

// 根据登录账号返回菜单列表
function findMenuListByUserAccount(data: {
  userAccount: string;
}): Promise<MenuListItem[]> {
  return commonFetch(
    "/crm-ems/v1/mallUser/mallUser/findMenuListByUserAccount",
    true,
    data
  );
}

// 登录-发送验证码
function sendPhoneLoginVerificationCode(
  phone: string
): Promise<ByUserNameOrPhoneUserInfoList[]> {
  return commonFetch(
    `/crm-mdm/v1/smsVerificationCode/smsVerificationCode/sendPhoneLoginVerificationCode?appType=2&phone=${phone}`,
    false,
    {}
  );
}

// 忘记密码-发送验证码
function fetchSendPhoneCode(
  phone: string
): Promise<ByUserNameOrPhoneUserInfoList[]> {
  return commonFetch(
    `/crm-mdm/v1/smsVerificationCode/smsVerificationCode/sendRetrievePasswordVerificationCode?appType=2&phone=${phone}`,
    false,
    {}
  );
}

// 忘记密码-校验验证码
function fetchCheckCode(data: {
  phone: string;
  code: string;
}): Promise<ByUserNameOrPhoneUserInfoList[]> {
  return commonFetch(
    `/crm-mdm/v1/smsVerificationCode/smsVerificationCode/checkVerificationCode?appType=2&phone=${data.phone}&verificationCode=${data.code}`,
    false,
    {}
  );
}

// 更改密码
function fetchUpdatePassword(data: {
  phone: string;
  code: string;
  password: string;
}): Promise<ByUserNameOrPhoneUserInfoList[]> {
  const password = Encrypt(data.password);
  return commonFetch(
    `/crm-mdm/v1/resetPassword/resetPassword/updatePasswordByPhoneAndVerificationCode?appType=2&phone=${data.phone}&verificationCode=${data.code}&password=${password}`,
    false,
    {}
  );
}

const productApi = {
  getFindByUserNameOrPhone,
  fetchSubmitByAccount,
  changeUserCurrentCustomer,
  findByUserAccount,
  findMenuListByUserAccount,
  sendPhoneLoginVerificationCode,
  fetchSendPhoneCode,
  fetchCheckCode,
  fetchUpdatePassword,
};

export default productApi;
